import { useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Icon } from '@iconify/react';
import PropTypes from 'prop-types';
import moreVerticalFill from '@iconify/icons-eva/more-vertical-fill';
import PersonAddAlt1OutlinedIcon from '@mui/icons-material/PersonAddAlt1Outlined';
import LinkOutlinedIcon from '@mui/icons-material/LinkOutlined';
import LinkOffOutlinedIcon from '@mui/icons-material/LinkOffOutlined';

// material
import { Menu, MenuItem, IconButton, ListItemIcon, ListItemText } from '@mui/material';
import { useAuth } from '../../customContextProviders/AuthContext';
import { APP_CONSTANTS, MERCHANT_MORE_MENU_ACTIONS, USER_LEVEL_TYPES } from '../../../URLConstants';

// ----------------------------------------------------------------------

MerchantsMoreMenu.propTypes = {
  handleUser: PropTypes.object,
  handleClicks: PropTypes.func,
  sx: PropTypes.object
};

export default function MerchantsMoreMenu({ handleUser, handleClicks, sx }) {
  const ref = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const { userLoginOrg, sessionUserData } = useAuth();
  const location = useLocation()
  const isHOAdmin = sessionUserData?.userLevel === USER_LEVEL_TYPES?.HO;
  const isAdmin =
    sessionUserData?.user?.role === APP_CONSTANTS?.USER_ROLE_ADMIN ||
    sessionUserData?.user?.role === APP_CONSTANTS?.USER_ROLE_SUPER_ADMIN;

  return (
    <>
      <IconButton
        data-testid="merchant_more_menu"
        sx={{ ...sx }}
        ref={ref}
        onClick={() => setIsOpen(true)}
      >
        <Icon icon={moreVerticalFill} width={20} height={20} />
      </IconButton>

      <Menu
        open={isOpen}
        anchorEl={ref.current}
        onClose={() => setIsOpen(false)}
        PaperProps={{
          sx: { width: 200, maxWidth: '100%' }
        }}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        {(location?.pathname !== '/dashboard/merchants' ||
          isHOAdmin ||
          (userLoginOrg === APP_CONSTANTS?.RSB_CLIENT_IDENTIFIER && isAdmin)) && (
          <MenuItem
            onClick={() => {
              setIsOpen(false);
              handleClicks(MERCHANT_MORE_MENU_ACTIONS?.UPDATE_MERCHANT);
            }}
            sx={{ color: 'text.secondary' }}
          >
            <ListItemIcon>
              <PersonAddAlt1OutlinedIcon />
            </ListItemIcon>
            <ListItemText primary="Update Merchant" primaryTypographyProps={{ variant: 'body2' }} />
          </MenuItem>
        )}
        {userLoginOrg === APP_CONSTANTS?.RSB_CLIENT_IDENTIFIER && location?.pathname !== '/dashboard/merchantOnboarding' && (
          <>
            {handleUser?.deviceId ? (
              <MenuItem
                onClick={() => {
                  setIsOpen(false);
                  handleClicks(MERCHANT_MORE_MENU_ACTIONS?.UNMAP_MERCHANT);
                }}
                sx={{ color: 'text.secondary' }}
              >
                <ListItemIcon>
                  <LinkOffOutlinedIcon />
                </ListItemIcon>
                <ListItemText
                  primary="UnMap Merchant"
                  primaryTypographyProps={{ variant: 'body2' }}
                />
              </MenuItem>
            ) : (
              <MenuItem
                onClick={() => {
                  setIsOpen(false);
                  handleClicks(MERCHANT_MORE_MENU_ACTIONS?.MAP_MERCHANT);
                }}
                sx={{ color: 'text.secondary' }}
              >
                <ListItemIcon>
                  <LinkOutlinedIcon  />
                </ListItemIcon>
                <ListItemText
                  primary="Map Merchant"
                  primaryTypographyProps={{ variant: 'body2' }}
                />
              </MenuItem>
            )}
          </>
        )}
      </Menu>
    </>
  );
}
